// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main.headerless {
    box-sizing: border-box;
    width: 100%;
    max-width: 1400px;
    min-width: 375px;
    margin: auto auto;
    color: var(--main-text-color);
    background-color: var(--main-background-color);
}
`, "",{"version":3,"sources":["webpack://./client/layouts/HeaderlessLayout.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,8CAA8C;AAClD","sourcesContent":["main.headerless {\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 1400px;\n    min-width: 375px;\n    margin: auto auto;\n    color: var(--main-text-color);\n    background-color: var(--main-background-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
